import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export function createSlug(text) {
  if (!text || typeof text !== 'string') {
    return 'default-slug';
  }
  return text
    .toLowerCase()
    // Önce Türkçe karakterleri İngilizce karakterlere çevir
    .replace(/ı/g, 'i')
    .replace(/ğ/g, 'g')
    .replace(/ü/g, 'u')
    .replace(/ş/g, 's')
    .replace(/ö/g, 'o')
    .replace(/ç/g, 'c')
    .replace(/İ/g, 'i')
    .replace(/Ğ/g, 'g')
    .replace(/Ü/g, 'u')
    .replace(/Ş/g, 's')
    .replace(/Ö/g, 'o')
    .replace(/Ç/g, 'c')
    // Sonra özel karakterleri temizle (sadece harf, rakam ve boşluk bırak)
    .replace(/[^a-z0-9\s]/g, '')
    // Birden fazla boşluğu tek boşluğa çevir
    .replace(/\s+/g, '-')
    // Başta ve sonda tire varsa kaldır
    .replace(/^-+|-+$/g, '');
}